import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const Staking = React.lazy(() => import("../page/Staking"));

const routes: AppRouteType[] = [
  {
    path: slugs.staking,
    component: Staking,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
